export default {"src":"/_next/static/media/Arrow-left-blu.767b4b45.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};